const data: any = [{"key":"feeplan-heading","copy":"My Fee Plan"},{"key":"feeplan-heading","copy":"My Pricing Plan","brand":"paypal"}];
export default data